<template>

    <aside class="l-d_sidebar">
        <nav class="l-d_sidebar__nav">
            <ul class="l-d_sidebar__menu">
                <li class="l-d_sidebar__item">
                    <router-link :to="{ name: 'Calendar'}" class="l-d_sidebar__link">
                        <span class="l-d_sidebar__link-icon l-d_sidebar__link-icon--calendar"></span>
                        <span class="l-d_sidebar__link-name l-d_sidebar__link-name">Kalendarz</span>
                    </router-link>
                </li>
                <li class="l-d_sidebar__item">
                    <router-link :to="{ name: 'Patients'}" class="l-d_sidebar__link">
                        <span class="l-d_sidebar__link-icon l-d_sidebar__link-icon--people"></span>
                        <span class="l-d_sidebar__link-name l-d_sidebar__link-name">Pacjenci</span>
                    </router-link>
                </li>
                <li class="l-d_sidebar__item">
                    <router-link :to="{ name: 'Settings'}" class="l-d_sidebar__link">
                        <span class="l-d_sidebar__link-icon l-d_sidebar__link-icon--cog"></span>
                        <span class="l-d_sidebar__link-name l-d_sidebar__item-name">Ustawienia</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </aside>

</template>


<script>

export default {

    name: 'TheDashboardSidebar'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.l-d_sidebar {
    flex-grow: 0;

    &__nav {
        display: flex;
        width: 90px;
        height: 100%;
        border-right: 1px solid $c-border;
        background-color: $c-white;
    }
    &__menu {
        width: 100%;
        padding: 45px 0 0 0;
        margin: 0;
    }
    &__item {
        width: 100%;
    }
    &__link {
        position: relative;
        display: block;
        width: 100%;
        padding: 20px 0;
        text-align: center;
        background-size: 100% 100%;
        background-position: 3px top;
        background-repeat: no-repeat;
        background-image: linear-gradient(to left, $c-primary 0, $c-primary 3px, transparent 3px);
        transition: background-position .2s ease-in-out;

        &-icon {
            display: inline-block;
            filter: grayscale(100%);
            width: 100%;
            height: 30px;
            background-repeat: no-repeat;
            background-position: center;
            transition: filter .2s ease-in-out;

            &--calendar {
                background-size: 1.6rem 1.6rem;
                background-image: url('#{$icons}/calendar.svg');
            }
            &--people {
                background-size: 2rem 2rem;
                background-image: url('#{$icons}/people.svg');
            }
            &--cog {
                background-size: 1.6rem 1.6rem;
                background-image: url('#{$icons}/cog.svg');
            }
        }
        &-name {
            font-size: 0.75rem;
            color: $c-secondary;
            text-transform: uppercase;
            font-weight: 600;
            transition: color .2s ease-in-out;
        }
        &.router-link-active {
            background-position: 0 0;
        }
        &:hover &,
        &.router-link-active & {
            &-icon {
                filter: grayscale(0);
            }
            &-name {
                color: $c-primary;
            }

            // Mobile
        }
    }
    @include bp($screen-lg) {
        position: fixed;
        z-index: 10;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;

        &__nav {
            width: 100%;
            height: 100%;
            border-right: none;
            border-top: 1px solid $c-border;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
        }
        &__menu {
            display: flex;
            width: 100%;
            height: 100%;
            padding: 0;
        }
        &__item {
            flex-grow: 1;
            width: auto;
            height: 100%;
            border-right: 1px solid $c-border;

            &:last-of-type {
                border-right: none;
            }
        }
        &__link {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            padding-bottom: 3px;
            height: 100%;
            background-position: left 3px;
            background-image: linear-gradient(to top, $c-primary 0, $c-primary 3px, transparent 3px);

            &-icon {
                width: 30px;
            }
            &-name {
                margin-left: 10px;
                white-space: nowrap;
                display: inline-block;
                overflow: hidden;
            }
        }
    }
    @include bp($screen-sm) {
        height: 40px;
    }
    @include bp(360px) {
        &__link-name {
            margin-left: 3px;
        }
    }
}

</style>
